export const CheckRouting = [
  {
    path: "/safety/check/list",
    name: "safety-check-list",
    meta: { title: "安全检查" },
    component: () =>
      import(/* webpackChunkName: "safety-check" */ "@/views/safety/check/list/index.vue"),
  },
  {
    hidden: true,
    path: "/safety/check/create",
    name: "safety-check-create",
    meta: { title: "新增安全检查", comName: "SafetyCheckFormCreate" },
    component: () =>
      import(/* webpackChunkName: "safety-check" */ "@/views/safety/check/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/safety/check/edit/:id",
    name: "safety-check-edit",
    meta: { title: "编辑安全检查", comName: "SafetyCheckFormCreate" },
    component: () =>
      import(/* webpackChunkName: "safety-check" */ "@/views/safety/check/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/safety/check/flowPrint/:id",
    name: "safety-check-print",
    meta: { title: "打印详情" },
    component: () =>
      import(/* webpackChunkName: "safety-check" */ "@/views/safety/check/form-print/index.vue"),
  },
  {
    hidden: true,
    path: "/safety/check/detail/:id",
    name: "safety-check-detail",
    meta: { title: "安全检查详情" },
    component: () =>
      import(/* webpackChunkName: "safety-check" */ "@/views/safety/check/form-detail/index.vue"),
  },
];
